import pathOr from 'ramda/src/pathOr'
import routeDescription from 'root/src/shared/descriptions/routes'
import { isLocalhost } from 'root/src/shared/util/envSelect'
import outputs from 'root/cfOutput'

const { domainName } = outputs

const protocol = isLocalhost ? 'http' : 'https'
const domain = isLocalhost ? 'localhost:8585' : domainName

export default routeId => `${protocol}://${domain}${pathOr('', [routeId, 'url'], routeDescription)}`
